export function PilotBanner({ children, className = "" }) {
  return (
    <p
      className={`text-xs rounded-lg border border-amber-500/30 bg-amber-500/10 text-amber-900 dark:text-amber-200 px-3 py-2 ${className}`}
      role="status"
    >
      <span className="font-semibold uppercase tracking-wide text-[10px] mr-1">Pilot</span>
      {children}
    </p>
  )
}
